export default {
  content: ''+
  '<div class="text-box">'+
  // '<h3 class="h3-line">(一)竞赛飞行时间：无</h3>'+
  '<h3 class="h3-line">竞赛飞行流程</h3>'+
  '<p class="text-line">1.比赛分为上下半场各3分钟，中场休息2分钟。比赛中进球后，暂停计时。重新开球后，恢复计时。得分区：A区得3分，B区和C区得1分。</p>'+
  '<p class="text-line">2.开球前，双方参赛选手将飞行器放置在得分区指定位置。进攻方将“得分球”整体“踢入”本方得分区，得相应分数。防守方在防守过程中，因操作不当造成“乌龙球”，进攻方得分。比赛时间结束时，分数高者获胜，分数相同记为平局。需通过“点球制胜法”决出胜负。</p>'+
  '<p class="text-line">3.比赛过程中，有一方得分，主裁暂停计时，重新开球，双方回到起始位置。</p>'+
  '<p class="text-line">4.正式比赛时的参赛选手人数不得少于两人（含两人）且参与比赛的器材不得少于两台（含两台），如参赛选手人数不足2人，则本场比赛该队成绩按0:3判负。如果该队当时比赛分差已经落后三分以上，则以当前比分计为本场比赛最终成绩。</p>'+
  '<p class="text-line">5.各队成员只得在各自规定活动区域活动，不得超出活动区域参加比赛。</p>'+
  // '<p class="text-line">6. 各队成员只得在各自规定活动区域活动，不得超出活动区域参加比赛。</p>'+
  '<img class="img-line" src="/work/static/img/uva/XKZ/t37.jpg" width="100%" />' +
  '<img class="img-line" src="/work/static/img/uva/XKZ/t38.jpg" width="100%" />' +
  '</div>'
}